<template>
  <el-dialog
    v-model="dialogFormVisible"
    title="重置密码"
    width="500px"
    @close="close"
  >
    <el-form label-width="100px" :model="form" :rules="rules" ref="form">
      <el-form-item label="用户名">
        {{ name }}
      </el-form-item>
      <el-form-item label="工号">
        {{ customId }}
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input v-model="form.password" show-password />
      </el-form-item>
      <el-form-item label="确认新密码" prop="subPassword">
        <el-input v-model="form.subPassword" show-password />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" @click="save">确 定</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {updatePassword} from '@/api/app'

export default {
  name: 'Reset',
  data() {
    return {
      name: '',
      customId: '',
      peopleId: '',
      form: {
        password: '',
        subPassword: '',
        peopleId:''
      },
      rules: {
        password: [
          { required: true, trigger: 'blur', message: '请输入新密码' },
        ],
        subPassword: [
          { required: true, trigger: 'blur', message: '请输入确认密码' },
        ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    showReset(row) {
      this.form.password = ''
      this.form.subPassword = ''
      this.form.peopleId = row.peopleId
      this.name = row.basic.name
      this.customId = row.basic.customId
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if (this.form.password != this.form.subPassword) {
            return this.$message.error('两次输入的密码不一致!')
          }
            this.$baseConfirm(
          `你确定要重置：${this.name}（${this.customId}）的密码吗`,
          null,
          async () => {
            await updatePassword(this.form)
            this.$baseMessage(
              '重置密码成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            this.close()
          }
        )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
